
import { ref } from 'vue'

import { t } from '@nextcloud/l10n'

import NcButton from '@nextcloud/vue/components/NcButton'
import NcCheckboxRadioSwitch from '@nextcloud/vue/components/NcCheckboxRadioSwitch'
import NcInputField from '@nextcloud/vue/components/NcInputField'
import NcModal from '@nextcloud/vue/components/NcModal'

import BreakoutRoomsParticipantsEditor from './BreakoutRoomsParticipantsEditor.vue'

import { useId } from '../../composables/useId.ts'
import { useBreakoutRoomsStore } from '../../stores/breakoutRooms.ts'

export default {
	name: 'BreakoutRoomsEditor',

	components: {
		BreakoutRoomsParticipantsEditor,
		NcButton,
		NcCheckboxRadioSwitch,
		NcInputField,
		NcModal,
	},

	props: {
		token: {
			type: String,
			required: true,
		},
	},

	emits: ['close'],

	setup() {
		const mode = ref('1')
		const amount = ref(2)
		const attendeeMap = ref('')
		const isEditingParticipants = ref(false)
		const isInvalidAmount = ref(false)
		const dialogHeaderId = `breakout-rooms-header-${useId()}`

		return {
			breakoutRoomsStore: useBreakoutRoomsStore(),
			mode,
			amount,
			attendeeMap,
			isEditingParticipants,
			isInvalidAmount,
			dialogHeaderId,
		}
	},

	computed: {
		modalTitle() {
			return this.isEditingParticipants
				? t('spreed', 'Assign participants to rooms')
				: t('spreed', 'Configure breakout rooms')
		},
	},

	watch: {
		amount(value) {
			this.isInvalidAmount = isNaN(value) || !this.$refs.inputField.$refs.input?.checkValidity()
		},
	},

	methods: {
		t,
		async handleCreateRooms() {
			try {
				await this.breakoutRoomsStore.configureBreakoutRooms({
					token: this.token,
					mode: this.mode,
					amount: this.amount,
				})
				this.$emit('close')
			} catch (error) {
				console.debug(error)
			}
		},
	},
}
